/* ============================================================
   YOOME MASCOT (Yoomi)
   - Speech bubbles pop in when Yoomi scrolls into view.
   - Tapping a chatty Yoomi hops and shows the next line.
   - The side pop-out (snippets/yh-mascot-peek.liquid) slides in,
     says hi, then tucks back to a shy peek.
   ============================================================ */
(function () {
  'use strict';

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var store = {
    get: function (k) { try { return window.sessionStorage.getItem(k); } catch (e) { return null; } },
    set: function (k, v) { try { window.sessionStorage.setItem(k, v); } catch (e) { /* private mode: ignore */ } }
  };
  document.documentElement.classList.add('yhm-ready');

  function hop(cat) {
    if (!cat || reduced) return;
    cat.classList.remove('is-hop');
    void cat.offsetWidth;
    cat.classList.add('is-hop');
  }

  // ---- Bubbles appear when Yoomi comes into view ----
  var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
    });
  }, { threshold: 0.5 }) : null;

  function wake(scope) {
    var cats = (scope || document).querySelectorAll('.yh-mascot:not([data-yhm-seen])');
    Array.prototype.forEach.call(cats, function (cat) {
      cat.setAttribute('data-yhm-seen', '');
      if (io && !reduced) io.observe(cat); else cat.classList.add('is-in');
    });
  }

  // ---- Chatty Yoomi: tap to hear the next line ----
  function talk(cat) {
    var lines = (cat.getAttribute('data-lines') || '').split('|').map(function (s) { return s.trim(); }).filter(Boolean);
    if (!lines.length) return;
    var i = ((parseInt(cat.getAttribute('data-i'), 10) || 0) + 1) % lines.length;
    cat.setAttribute('data-i', i);
    var bubble = cat.querySelector('.yh-mascot__bubble');
    if (!bubble) { bubble = document.createElement('span'); bubble.className = 'yh-mascot__bubble'; cat.appendChild(bubble); }
    bubble.textContent = lines[i];
    cat.classList.add('is-in');
    hop(cat);
  }
  document.addEventListener('click', function (e) {
    var cat = e.target.closest && e.target.closest('[data-yh-mascot]');
    if (cat) talk(cat);
  });
  document.addEventListener('keydown', function (e) {
    if ((e.key === 'Enter' || e.key === ' ') && e.target.matches && e.target.matches('[data-yh-mascot]')) { e.preventDefault(); talk(e.target); }
  });

  // ---- Yoomi, the shop companion ----
  // Home spot: peeking in from the left edge of the screen. Every so often Yoomi pays a visit
  // (waddles across the bottom of the screen, knocks on the "glass", or pops out with a tip),
  // naps when the shopper goes quiet, cheers when something goes in the cart and waves at the
  // footer. Visits pause while a drawer is open or the tab is hidden; the × sends Yoomi away
  // for the rest of the visit.
  function initCompanion() {
    var root = document.querySelector('[data-yh-peek]');
    if (!root || store.get('yhPeekGone') === '1') return;
    var catBtn = root.querySelector('[data-yh-peek-cat]');
    var text = root.querySelector('[data-yh-peek-text]');
    var link = root.querySelector('[data-yh-peek-link]');
    var closeBtn = root.querySelector('[data-yh-peek-close]');
    function attr(name, fallback) { return root.getAttribute(name) || fallback; }
    function parse(l) {
      var bar = l.indexOf('|');
      return bar > -1 ? { text: l.slice(0, bar).trim(), url: l.slice(bar + 1).trim() } : { text: l.trim(), url: '' };
    }
    var lines = attr('data-lines', '').split(/\r?\n/).map(parse).filter(function (l) { return l.text; });
    if (!lines.length) lines = [{ text: 'Hi there!', url: '' }];
    var visitsOn = attr('data-visits', 'on') !== 'off';
    var every = Math.max(15, parseFloat(attr('data-every', '35')) || 35) * 1000;
    var NAP_AFTER = 45000, MAX_VISITS = 6;

    // Carry on from where Yoomi left off on the last page, so each page shows a new tip
    var index = (parseInt(store.get('yhPeekLine'), 10) || 0) - 1;
    var timers = [], visitTimers = [], plan = null, visit = null;
    var visits = 0, lastKind = '', asleep = false, gone = false, lastInput = Date.now();

    function clear(list) { list.forEach(window.clearTimeout); list.length = 0; }
    function nextTip() {
      index = (index + 1) % lines.length;
      store.set('yhPeekLine', String(index + 1));
      return lines[index];
    }
    function blocked() {
      return document.hidden || document.body.style.overflow === 'hidden' || !!document.querySelector('.cart-drawer.open, .search-drawer.open');
    }
    function busy() { return !!visit || root.classList.contains('is-away'); }
    // Run fn once Yoomi is free (no visit on, no drawer open); give up after ~40s
    function whenFree(fn, tries) {
      tries = tries || 0;
      if (gone || tries > 40) return;
      if (busy() || blocked()) { window.setTimeout(function () { whenFree(fn, tries + 1); }, 1000); return; }
      fn();
    }

    // --- the side spot ---
    function peekOut(line, ms) {
      clear(timers);
      ms = ms || 7000;
      asleep = false;
      root.classList.remove('is-shy', 'is-asleep', 'is-away');
      root.classList.add('is-out', 'is-talking');
      text.textContent = line.text;
      if (line.url) { link.href = line.url; link.hidden = false; } else { link.hidden = true; }
      timers.push(window.setTimeout(function () { root.classList.remove('is-talking'); }, ms));
      timers.push(window.setTimeout(function () { root.classList.add('is-shy'); }, ms + 2000));
    }
    function comeBack() { root.classList.remove('is-away', 'is-out'); root.classList.add('is-shy'); }

    // --- visits ---
    function spawn(kind, line) {
      var tpl = root.querySelector('template[data-yh-tpl="' + kind + '"]');
      if (!tpl) return null;
      var el = document.createElement('div');
      el.className = 'yh-visit yh-visit--' + kind;
      el.innerHTML = tpl.innerHTML;
      var bubble = document.createElement('div');
      bubble.className = 'yh-visit__bubble';
      if (kind === 'knock') {
        var knock = document.createElement('strong');
        knock.className = 'yh-visit__knock';
        knock.textContent = attr('data-knock', 'Knock knock!');
        bubble.appendChild(knock);
      }
      var p = document.createElement('p');
      p.textContent = line.text;
      bubble.appendChild(p);
      if (line.url && kind === 'knock') {
        var a = document.createElement('a');
        a.className = 'yh-visit__link';
        a.href = line.url;
        a.textContent = 'Show me →';
        bubble.appendChild(a);
      }
      el.appendChild(bubble);
      document.body.appendChild(el);
      return el;
    }
    function payVisit(kind) {
      visits++;
      lastKind = kind;
      if (kind === 'tip') { peekOut(nextTip()); return; }
      var line = nextTip();
      // Yoomi slips out of the side spot first, so there's only ever one Yoomi on screen
      clear(timers);
      root.classList.remove('is-talking', 'is-asleep');
      root.classList.add('is-away');
      visitTimers.push(window.setTimeout(function () {
        visit = spawn(kind, line);
        if (!visit) { comeBack(); return; }
        var length = 10500;
        if (kind === 'knock') {
          length = 7400;
          window.requestAnimationFrame(function () { window.requestAnimationFrame(function () { if (visit) visit.classList.add('is-on'); }); });
          visitTimers.push(window.setTimeout(function () { if (visit) visit.classList.remove('is-on'); }, 6600));
        }
        visitTimers.push(window.setTimeout(function () {
          if (visit) { visit.remove(); visit = null; }
          if (!gone) comeBack();
        }, length));
      }, 650));
    }
    function planNext(ms) {
      window.clearTimeout(plan);
      if (visitsOn && !gone) plan = window.setTimeout(tick, ms);
    }
    function tick() {
      if (gone || asleep || visits >= MAX_VISITS) return;
      if (busy() || blocked() || root.classList.contains('is-talking')) { planNext(5000); return; }
      var kinds = reduced ? ['tip'] : ['walk', 'knock', 'tip'];
      var choices = kinds.filter(function (k) { return k !== lastKind; });
      if (!choices.length) choices = kinds;
      payVisit(choices[Math.floor(Math.random() * choices.length)]);
      planNext(every * (0.8 + Math.random() * 0.4));
    }

    // --- naps when the shopper goes quiet, wakes when they're back ---
    function nap() {
      if (asleep || busy() || gone) return;
      asleep = true;
      clear(timers);
      // the shopper's away, so Yoomi can come right out for its nap
      root.classList.remove('is-shy', 'is-talking');
      root.classList.add('is-out', 'is-asleep');
    }
    function onInput() {
      lastInput = Date.now();
      if (asleep && !gone) {
        peekOut(parse(attr('data-welcome-back', 'Welcome back!')), 4500);
        planNext(every);
      }
    }
    ['scroll', 'pointerdown', 'pointermove', 'keydown', 'touchstart'].forEach(function (ev) {
      window.addEventListener(ev, onInput, { passive: true });
    });
    var napCheck = window.setInterval(function () {
      if (!gone && !document.hidden && Date.now() - lastInput > NAP_AFTER) nap();
    }, 5000);

    // --- cheers when something goes in the cart ---
    var countEl = document.getElementById('CartCount');
    if (countEl && 'MutationObserver' in window) {
      var lastCount = parseInt(countEl.textContent, 10) || 0;
      new MutationObserver(function () {
        var n = parseInt(countEl.textContent, 10) || 0;
        if (n > lastCount) {
          whenFree(function () {
            peekOut(parse(attr('data-yay', 'Yay, great pick!')), 4500);
            hop(catBtn.querySelector('.yh-mascot'));
          });
        }
        lastCount = n;
      }).observe(countEl, { childList: true, characterData: true, subtree: true });
    }

    // --- waves at the footer (once per page, only after some scrolling) ---
    var footer = document.querySelector('.site-footer');
    if (footer && 'IntersectionObserver' in window) {
      var footerIo = new IntersectionObserver(function (entries) {
        var seen = entries.some(function (e) { return e.isIntersecting; });
        if (!seen || window.scrollY < window.innerHeight * 0.6) return;
        footerIo.disconnect();
        whenFree(function () { peekOut(parse(attr('data-bye', 'See you soon!')), 6000); });
      }, { threshold: 0.25 });
      footerIo.observe(footer);
    }

    // --- tap and close ---
    catBtn.addEventListener('click', function () {
      if (asleep) { onInput(); return; }
      peekOut(nextTip());
      hop(catBtn.querySelector('.yh-mascot'));
    });
    closeBtn.addEventListener('click', function () {
      gone = true;
      clear(timers);
      clear(visitTimers);
      window.clearTimeout(plan);
      window.clearInterval(napCheck);
      if (visit) { visit.remove(); visit = null; }
      root.classList.remove('is-out', 'is-talking', 'is-shy', 'is-asleep');
      store.set('yhPeekGone', '1');
      window.setTimeout(function () { root.hidden = true; }, 700);
    });

    // Handy for previewing in the theme editor console: YoomeMascot.visit('walk' | 'knock' | 'tip'), YoomeMascot.nap()
    window.YoomeMascot.visit = function (kind) { whenFree(function () { payVisit(kind || 'walk'); }); };
    window.YoomeMascot.nap = nap;

    // Say hi straight away: the short pause just lets the page paint so the slide-in is seen
    root.hidden = false;
    var delay = Math.max(0.4, parseFloat(attr('data-delay', '0')) || 0) * 1000;
    window.setTimeout(function () { peekOut(nextTip()); }, delay);
    planNext(Math.max(15000, every * 0.6));
  }

  window.YoomeMascot = { wake: wake };
  wake();
  initCompanion();
  document.addEventListener('shopify:section:load', function (e) { wake(e.target); });
})();
